import * as yup from 'yup';

export const addUserSchema = yup.object().shape({
  email: yup.string().trim().email('Enter valid e-mail address').required('Email is required'),
  given_name: yup.string().trim().required('First name is required'),
  family_name: yup.string().trim().required('Last name is required'),
  phone_number: yup
    .string()
    .trim()
    .transform((v) => (typeof v === 'string' && v.trim() === '' ? undefined : v))
    .nullable()
    .notRequired()
    .test('is-valid-phone', 'Enter a valid phone number', (value) => {
      if (value === undefined || value === null) return true;
      const v = String(value).trim();
      if (v.length === 0) return true;
      // Allow only digits, optional leading +, and hyphens
      return /^\+?[0-9-]+$/.test(v);
    })
});
